import * as signalR from '@microsoft/signalr';
import apiRequestHeaders from '../apiRequestHeaders';

class SignalRPricingService {
  public connection: signalR.HubConnection;

  // eslint-disable-next-line class-methods-use-this
  public onReceiveMessage: (
    accommodationNumber: string,
    accommodationName: string,
    seasonRatesChangedCount: string,
  ) => void = () => {};

  // eslint-disable-next-line class-methods-use-this
  public onReceiveCopyMessage: (
    accommodationNumber: string,
    accommodationName: string,
    seasonRatesCopiedCount: string,
    seasonRatesNotCopiedCount: string,
  ) => void = () => {};

  // eslint-disable-next-line class-methods-use-this
  public onReceiveCopySummary: (
    accommodationsCopiedCount: string,
    accommodationsNotCopiedCount: string,
  ) => void = () => {};

  // eslint-disable-next-line class-methods-use-this
  public onReceiveUpdateSummary: (
    accommodationsModifiedCount: string,
    accommodationsNotModifiedCount: string,
  ) => void = () => {};

  // eslint-disable-next-line class-methods-use-this
  public onReceiveRevertSummary: (
    revertedCount: string,
    conflictCount: string,
  ) => void = () => {};

  constructor() {
    console.log('SignalR Service Created');
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl('/signalr-hubs/season-rate-hub', {
        headers: apiRequestHeaders.csrfHeader(),
      })
      .configureLogging(signalR.LogLevel.Error)
      .withAutomaticReconnect()
      .build();

    this.connection.on(
      'ReceiveSeasonRateBulkUpdateMessage',
      (
        accommodationNumber: string,
        accommodationName: string,
        seasonRatesChangedCount: string,
      ) => {
        this.onReceiveMessage(
          accommodationNumber,
          accommodationName,
          seasonRatesChangedCount,
        );
      },
    );

    this.connection.on(
      'ReceiveSeasonRateBulkCopyMessage',
      (
        accommodationNumber: string,
        accommodationName: string,
        seasonRatesCopiedCount: string,
        seasonRatesNotCopiedCount: string,
      ) => {
        this.onReceiveCopyMessage(
          accommodationNumber,
          accommodationName,
          seasonRatesCopiedCount,
          seasonRatesNotCopiedCount,
        );
      },
    );

    this.connection.on(
      'ReceiveSeasonRateBulkCopySummary',
      (
        accommodationsCopiedCount: string,
        accommodationsNotCopiedCount: string,
      ) => {
        this.onReceiveCopySummary(
          accommodationsCopiedCount,
          accommodationsNotCopiedCount,
        );
      },
    );

    this.connection.on(
      'ReceiveSeasonRateBulkUpdateSummary',
      (
        accommodationsModifiedCount: string,
        accommodationsNotModifiedCount: string,
      ) => {
        this.onReceiveUpdateSummary(
          accommodationsModifiedCount,
          accommodationsNotModifiedCount,
        );
      },
    );

    this.connection.on(
      'ReceiveSeasonRateRevertSummary',
      (revertedCount: string, conflictCount: string) => {
        this.onReceiveRevertSummary(revertedCount, conflictCount);
      },
    );
  }

  public startConnection = async () => {
    try {
      await this.connection.start();
      console.log('SignalR Connected.');
    } catch (err) {
      console.error('SignalR Connection Error: ', err);
    }
  };

  public stopConnection = async () => {
    try {
      await this.connection.stop();
      console.log('SignalR Disconnected.');
    } catch (err) {
      console.error('SignalR Disconnection Error: ', err);
    }
  };
}

export default new SignalRPricingService();
